"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEventQueue = function () {
    if (!global.adobeDataLayer) {
        global.adobeDataLayer = [];
    }
    return global.adobeDataLayer;
};
exports.default = getEventQueue;
